import { dispatcher, api } from '@unicus/react-ui-kit';

export const INVOICE = 'INVOICE';

export const INVOICE_SET_DEFAULT_INVOICE_SETTINGS =
  'INVOICE_SET_DEFAULT_INVOICE_SETTINGS';
export const INVOICE_SET_DEFAULT_INVOICE_SETTINGS_FINISHED =
  'INVOICE_SET_DEFAULT_INVOICE_SETTINGS_FINISHED';

export const setInvoiceSettingsDefault = (settingsId, onSuccess) => async (
  dispatch
) => {
  await dispatcher.dispatchResouceAction({
    dispatch,
    resource: 'invoices/settings',
    actionType: INVOICE_SET_DEFAULT_INVOICE_SETTINGS,
    effect: async () => api.put(`invoices/settings-default/${settingsId}`),
    onSuccess
  });
};
